module.exports = __webpack_public_path__ + "static/media/content-1@768.802e3cc1.png";